import '../../css/modules/persons.css';

export class Persons {

  constructor() {

  }

}